import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import SuperAdminPanel from '../components/admin/SuperAdminPanel';
import PlatformOverview from '../components/admin/PlatformOverview';
import { useAuth } from '../context/AuthContext';
import { isOrgSuperAdmin } from '../utils/auth';

function SuperAdminDashboard() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isSuperAdmin = isOrgSuperAdmin(user);

  useEffect(() => {
    if (!isSuperAdmin) navigate('/', { replace: true });
  }, [isSuperAdmin, navigate]);

  if (!isSuperAdmin) return null;

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Super Admin"
        subtitle="Cross-organisation management, billing and platform settings"
        icon={<Shield className="h-6 w-6 text-white" />}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Read-only platform view first: what is out there, before the
            controls that change it. */}
        <div className="mb-8">
          <PlatformOverview />
        </div>

        <div className="mb-8 p-6 bg-amber-50 border border-amber-200 rounded-xl">
          <SuperAdminPanel />
        </div>

      </div>
    </div>
  );
}

export default SuperAdminDashboard;
